import type { FC, ReactNode } from 'react'
import { useState } from 'react'
import { Popover } from '@systemeio/components'
import { GifIcon } from '@systemeio/icons'
import { twMerge } from 'tailwind-merge'
import type { GIFObject } from 'modules/attachments/api/tenor.types'
import { GifPickerPanel } from './gif-picker-panel'

interface GifPickerProps {
  className?: string
  onSelect: (gif: GIFObject) => void
  iconClassName?: string
  onOpenChange?: (open: boolean) => void
}

export const GifPicker: FC<GifPickerProps> = ({
  onSelect,
  className,
  iconClassName,
  onOpenChange,
}): ReactNode => {
  const [isOpen, setIsOpen] = useState(false)
  const changeOpen = (open: boolean): void => {
    setIsOpen(open)
    onOpenChange?.(open)
  }

  const closePicker = (): void => {
    changeOpen(false)
  }

  return (
    <div className={twMerge('flex', className)}>
      <Popover.Root open={isOpen} onOpenChange={changeOpen}>
        <Popover.Trigger type="button" aria-label="Toggle GIF Picker">
          <GifIcon className={twMerge('size-6', iconClassName)} />
        </Popover.Trigger>
        <Popover.Portal>
          <Popover.Positioner
            side="top"
            sideOffset={10}
            collisionAvoidance={{ fallbackAxisSide: 'none' }}
          >
            <Popover.Popup className="z-30">
              <GifPickerPanel onSelect={onSelect} onClose={closePicker} />
            </Popover.Popup>
          </Popover.Positioner>
        </Popover.Portal>
      </Popover.Root>
    </div>
  )
}
